// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import {
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonFooter,
  IonGrid,
  IonItem,
  IonLabel,
  IonModal,
  IonRow,
  IonToolbar
} from "@ionic/react"
import { useState } from "react"
import { useLocales } from "react-localized"


interface ModalProps {
  ctrl: FullscreenInputCtrl,
  children: React.ReactNode
  inputComponent: (props: FullscreenInputCtrl) => React.ReactElement
}


const FullscreenInput: React.FC<ModalProps> = ({
  children,
  ctrl,
  inputComponent
}) => {
  const {gettext} = useLocales()
  return (
    <IonModal animated={false} backdropDismiss={false} className="page-modal" isOpen={ctrl.isOpen()}>
      <IonContent>
        <main>
          <IonGrid>
            <IonRow>
              <IonCol sizeMd="8" sizeLg="6" sizeXl="4">
                {children}
                {inputComponent(ctrl)}
              </IonCol>
            </IonRow>
          </IonGrid>
        </main>
      </IonContent>
      <IonFooter>
        <IonToolbar>
          <IonButtons slot="start">
            <IonButton color="medium" onClick={() => {
              ctrl.closeModal()
            }}>
              {gettext("Cancel")}
            </IonButton>
          </IonButtons>
        </IonToolbar>
      </IonFooter>
    </IonModal>
  )
}


interface FullscreenInputCtrl {
  isOpen(): boolean
  closeModal: () => void
}


const FullscreenInputItem: React.FC<{
  children: React.ReactNode,
  inputComponent: (props: FullscreenInputCtrl) => React.ReactElement
  value: any,
  placeholder: string,
  title: string
}> = ({
  children,
  inputComponent,
  placeholder,
  title,
  value
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false)
  return (
    <>
      <IonItem
        className="clickable"
        detail={true}
        lines="full"
        onClick={() => {
          setIsOpen(true)
        }}
      >
        <IonLabel>
          <h2>{title}</h2>
          <p>{placeholder}</p>
        </IonLabel>
      </IonItem>
      <FullscreenInput
        ctrl={{
          isOpen: () => isOpen,
          closeModal: () => setIsOpen(false)
        }}
        inputComponent={inputComponent}
      >
        {children}
      </FullscreenInput>
    </>
  )
}


export { FullscreenInputItem, FullscreenInput }